<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :modal="false"
    width="800px"
    custom-class="custom-dialog custom-dialog-big-close"
    :append-to-body="true"
    :close-on-click-modal="false"
    :before-close="beforeClose"
  >
    <div slot="title" class="title">
      <div class="title-name">list上传</div>
      <div class="side-title">
        <b style="color:red">*</b
        >为必填项，同一家公司和年份在同一时间上传多张图片或者excel，判定为一个list。传输完成点击上传完成，关闭本窗口
        <br />
        <b style="color:red">（单个文件不要大于20M）</b>
      </div>
      <div class="handle-btn"></div>
    </div>
    <el-row :gutter="16" style="margin-bottom:16px" type="flex" align="center">
      <el-col :span="8" class="list-box-item">
        <span class="list-box-label">公司名称</span>
        <el-autocomplete
          v-model="listOption['公司']"
          size="mini"
          :fetch-suggestions="searchCompany"
          placeholder="请输入公司名称"
        >
          <template slot-scope="{ item }">
            <span v-if="item.highlight" class="keyword-item" v-html="item.highlight"></span>
            <span v-else> <i class="el-icon-time"></i> &nbsp;{{ item.value }} </span>
          </template>
        </el-autocomplete>
      </el-col>
      <el-col :span="8" class="list-box-item">
        <span class="list-box-label"><b style="color:red">*</b>list年份</span>
        <el-input v-model="listOption['年份']" placeholder="如：2020" size="mini" />
      </el-col>
      <el-col :span="8" class="list-box-item">
        <span class="list-box-label">职能模块</span>
        <el-select v-model="listOption['职能模块']" size="mini" filterable multiple placeholder="请选择">
          <el-option v-for="item in categories" :key="item._id" :value="item.名称" :label="item.名称"></el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row type="flex" align="center" style="border-bottom: 2px solid #f3f3f3;padding-bottom:16px;margin-bottom:16px">
      <span class="list-box-label">备注:</span>
      <el-input
        v-model="listOption['备注']"
        type="textarea"
        :autosize="{ minRows: 2, maxRows: 6 }"
        placeholder="特殊要求可备注给数据同事"
      ></el-input>
    </el-row>
    <!-- :on-success="afterSuccess"
        :on-error="handleError"
        :data="{ type: type || fileType }"
        :on-change="onChange"
        :limit="limit"
        :onProgress="onProgress"
        :on-exceed="onExceed"
        :before-upload="beforeUpload" -->
    <el-row class="upload-wapper list-upload-custom-progress">
      <el-upload
        ref="upload"
        :action="uploadUrl"
        drag
        with-credentials
        multiple
        :on-success="afterSuccess"
        :on-error="handleError"
        :on-progress="onProgress"
        :data="otherData"
        :before-upload="beforeUpload"
      >
        <i class="el-icon-upload" />
        <div class="el-upload__text">将文件拖到此处，或 <em>点击上传</em></div>
      </el-upload>
    </el-row>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" size="small" class="custom-primary-plain" :disabled="loading" @click="confirmListDialog"
        >全部提交</el-button
      >
    </span>
  </el-dialog>
</template>
<script>
export default {
  name: 'UploadListDialog',
  data() {
    return {
      dialogVisible: false,
      listOption: { 公司: '', 年份: '', 职能模块: [], 备注: '', fileList: [] },
      categories: app.categories || [],
      uploadUrl: `${window.host}/uploads`,
      finish: false,
      error: [],
      finishFile: {},
      otherData: { type: 'list' },
      companyRes: [],
      loading: false,
    }
  },
  mounted() {
    this.categories = app.categories
  },
  methods: {
    async searchCompany(queryString, cb) {
      const keywords = (queryString || '').trim()
      if (!keywords) {
        cb([])
      }
      if (keywords !== queryString || this.keywordsLoading) {
        cb(this.companyRes)
      } else {
        this.companyRes = await this.createFilter(keywords, ['公司'])
        cb(this.companyRes)
      }
    },
    async createFilter(keywords, fields) {
      this.keywordsLoading = true
      const arr = keywords.split(/\s+/)
      const keyword = arr.pop()
      const highlight = arr.join(' ')
      const q = { keyword }
      if (fields) q.fields = fields
      const res = await app.service('radish').listKeywords(q)
      this.keywordsLoading = false
      if (res.status == 'success') {
        return res.data.map(dt => {
          const item = {
            value: highlight ? `${highlight} ${dt.keyword}` : dt.keyword,
            highlight: `<span>${highlight}</span>${highlight ? ' ' : ''}${dt.keyword.replace(
              keyword,
              `<span>${keyword}</span>`,
            )}`,
          }
          return item
        })
      }
      return []
    },
    beforeClose(done) {
      this.$confirm('是否确定关闭上传窗口', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      })
        .then(() => {
          this.$refs.upload.clearFiles()
          done()
        })
        .catch(() => {})
    },
    visible() {
      this.dialogVisible = true
      this.categories = app.categories
    },
    async confirmListDialog() {
      if (!this.listOption.年份) return this.$message.error('请输入年份')
      if (this.listOption.fileList.length === 0 && !this.finish) return this.$message.error('请上传文件')
      if (!this.finish) return this.$message.error('请等待文件上传完成')
      if (!this.finishFile.md5) return this.$message.error('上传失败，请重新上传后重试')
      if (this.loading) {
        return this.$message.error('提交中，请稍后')
      }
      this.loading = true
      try {
        await app.service('file').addKpi({
          type: 'LIST',
          content: {
            md5: this.finishFile.md5,
            uploader: app.user.提供者 || app.user.account,
            originalname: this.finishFile.originalname,
            _id: this.finishFile.md5,
          },
        })
        const res = await app.service('company').modifyDocument({
          query: { md5: this.finishFile.md5 },
          data: { listOption: this.listOption, type: 'list' },
        })
        this.dialogVisible = false
        this.listOption = { 公司: '', 年份: '', 职能模块: [], 备注: '', fileList: [] }
        this.finish = false
        this.error = []
        this.finishFile = {}
        this.$refs.upload.clearFiles()
      } catch (e) {
        this.$message.error('提交失败，请重试')
      }
      this.loading = false
    },
    beforeUpload() {
      if (this.finish) {
        this.finish = false
        this.listOption.fileList.push(this.finishFile)
      }
    },
    async afterSuccess(response, file, fileList) {
      console.log('success-----------------------')
      this.listOption.fileList.push(response[0])
      const fileListLength = this.listOption.fileList.length + this.error.length
      if (fileListLength === fileList.length) {
        this.finish = true
        this.finishFile = response[0]
        this.listOption.fileList.pop()
        this.$alert(`${this.listOption.公司}-${this.listOption.年份}上传完毕,可以提交`, 'list文件上传完毕', {
          confirmButtonText: '确定',
        })
        const res = await app.service('company').modifyDocument({
          query: { _id: { $in: this.listOption.fileList.map(f => f._id) } },
          data: { type: 'listAtt', mainFile: this.finishFile.md5 },
        })
      }
    },
    async handleError(err, file, fileList) {
      console.log('success-----------------------')
      this.error.push(file)
      this.$alert(
        `${this.listOption.公司}-${this.listOption.年份}-${file.name}上传失败,请尝试重新上传`,
        'list文件上传失败',
        {
          confirmButtonText: '确定',
        },
      )
      const fileListLength = this.listOption.fileList.length + this.error.length
      if (fileListLength === fileList.length) {
        console.log('finish')
        this.finish = true
        this.finishFile = this.listOption.fileList.pop()
        const res = await app.service('company').modifyDocument({
          query: { _id: { $in: this.listOption.fileList.map(f => f._id) } },
          data: { type: 'listAtt', mainFile: this.finishFile.md5 },
        })
      }
      // console.log('error-----------------------')
      // console.log(err, file, fileList)
    },
    onProgress(event, file, fileList) {
      this.finish = false
      // console.log('progress-----------------------')
      // console.log(event, file, fileList)
    },
  },
}
</script>
<style scoped>
.list-box-item {
  display: flex;
  align-items: center;
}
.list-box-label {
  display: block;
  width: 70px;
  flex-shrink: 0;
}
</style>
<style>
.el-upload-list.el-upload-list--text {
  max-height: 95px;
  overflow-y: scroll;
  padding-bottom: 5px;
}
.list-upload-custom-progress li.el-upload-list__item.is-uploading {
  display: flex;
}
.list-upload-custom-progress .el-upload-list__item.is-success::after {
  position: absolute;
  right: 24px;
  top: 50%;
  margin-top: -4px;
  width: 67.7%;
  height: 8px;
  background-color: #409eff;
  text-align: right;
  content: '';
  display: block;
  border-radius: 100px;
  margin-right: 42px;
}
.list-upload-custom-progress .el-upload-list__item .el-upload-list__item-name {
  width: 135px;
  flex-shrink: 0;
}
.list-upload-custom-progress .el-progress.el-progress--line {
  display: flex;
  align-items: center;
  position: relative;
  top: 0;
  width: 80%;
}
.list-upload-custom-progress .el-progress-bar__outer {
  height: 8px !important;
  margin-right: 20px;
}
.list-upload-custom-progress .el-progress__text {
  position: relative !important;
  top: 0 !important;
  white-space: nowrap;
  width: 36px;
  flex-shrink: 0;
  display: block;
}
.list-upload-custom-progress .el-upload-list__item .el-icon-close {
  z-index: 10;
}
.custom-dialog-big-close .el-dialog__close.el-icon.el-icon-close {
  position: relative;
  top: -5px;
  left: 10px;
  font-size: 26px;
}
</style>
